import { ISolicitudDocumentoModel } from "../../interfaces/solicitud/documento/ISolicitudDocumentModel";
import { ISolicitudVehiculoValidarModel } from "../../interfaces/solicitud/vehiculos/ISolicitudVehiculoValidarModel";
import { SolicitudDocumentoModel } from "../documento/SolicitudDocumentoModel";

export class SolicitudVehiculoValidarModel implements ISolicitudVehiculoValidarModel {
    idSolicitudVehiculo: number;    
    documentos: ISolicitudDocumentoModel[];
    comentarios: string;
    idEstado: number;

    constructor(){
        this.idSolicitudVehiculo = 0;
        this.documentos = new Array<SolicitudDocumentoModel>();
        this.comentarios = '';
        this.idEstado = 0;
    }
}